import React from 'react'

const Todo = ({todo,handleComplete}) => {
  return (
    <div className="todo-item">
        <div className="checkbox" >
            <input type="checkbox"  onChange = {() => handleComplete(todo.id)} />
        </div>
        <span className='todo-name' style={{textDecoration : todo.isCompleted ? "line-through" : "none"}}>{` ${todo.name}`}</span>
    </div>
  )
}

export default Todo